import { memo } from "react";
import { Box, Divider, Grid2, Tooltip, Typography } from "@mui/material";

interface DocumentTooltip {
    children: React.ReactElement;
    placement?:
        | "right"
        | "left"
        | "top"
        | "bottom"
        | "top-start"
        | "top-end"
        | "bottom-start"
        | "bottom-end"
        | "right-start"
        | "right-end"
        | "left-start"
        | "left-end"
        | undefined;
    title: string;
    disabled?: boolean;
    hoverTitle?: string;
}

const DocumentTooltip = memo(({ children, title, hoverTitle, placement, disabled }: DocumentTooltip) => {
    const TooltipTitle = () => {
        return (
            <Grid2 container size={12}>
                <Grid2 size={16} p={0.75}>
                    <Typography fontWeight={500} variant="body2">{hoverTitle}</Typography>
                </Grid2>

                <Grid2 size={12}>
                    <Divider flexItem color={"white"} />
                </Grid2>

                <Grid2 size={12} p={0.75}>
                    <Typography variant={"body2"} fontSize={12}>
                        {title}
                    </Typography>
                </Grid2>
            </Grid2>
        );
    };

    if (disabled) return <Box>{children}</Box>;

    return (
        <Tooltip title={<TooltipTitle />} placement={placement}>
            {children}
        </Tooltip>
    );
});

export default DocumentTooltip;
